module.exports = __webpack_public_path__ + "img/jbisumari_card_img.cd9d5755.png";